import { takeEvery, put } from "redux-saga/effects";

import axios from "axios";

import hashtagType from "./hashtagType";
import { hashtagApi } from "../../../utility/api/apiList";
import { successFetchedHashtag } from "./hashtagActions";

export function* startfetchingHashtag (action) {
    try {
        const response =yield axios.get(hashtagApi)
        const handle = yield put(successFetchedHashtag(response.data.results))

    }catch(err) {

    }
    
}


export function* fetchHashtag (){
yield takeEvery(hashtagType.START_FETCHING_HASHTAG,startfetchingHashtag )
}